import { CONTACT_URL, MARKETING_SITE } from "@client/lib/site-links";

const links = [
	{ label: "About", href: `${MARKETING_SITE}/about` },
	{ label: "Privacy Policy", href: `${MARKETING_SITE}/privacy` },
	{ label: "Terms of Service", href: `${MARKETING_SITE}/terms` },
	{ label: "Refund Policy", href: `${MARKETING_SITE}/refund` },
	{ label: "Contact", href: CONTACT_URL },
];

export function AppFooter() {
	return (
		<footer className="border-border border-t bg-background">
			<div className="mx-auto max-w-screen-xl px-4 py-4">
				<div className="flex flex-col items-center justify-between gap-3 sm:flex-row">
					<div className="text-center sm:text-left">
						<p className="text-muted-foreground text-xs">
							© 2026 LLMGenerator. All rights reserved.
						</p>
						<p className="text-muted-foreground text-xs">
							GUSE LTDA · CNPJ: 47.758.713/0001-82
						</p>
					</div>
					<nav className="flex flex-wrap justify-center gap-x-4 gap-y-1">
						{links.map((link) => (
							<a
								key={link.href}
								href={link.href}
								target="_blank"
								rel="noopener noreferrer"
								className="text-muted-foreground text-xs transition-colors hover:text-foreground"
							>
								{link.label}
							</a>
						))}
					</nav>
				</div>
			</div>
		</footer>
	);
}
